module.exports = __webpack_public_path__ + "img/thinking_face.dcd8ea2e.gif";